import * as act from "./constants";
import { cloneDeep } from "lodash";
// import * as selectors from "./selectors";

const uuid4 = require("uuid/v4");

const defaultState = {
  links: [],
  sessions: [],
  blocks: [],
  is_open: false,
  tag_search_results: [],
  tab_showing: "clipboard",
  tagging_type: "program",
};

let links, sessions, blocks;

export default function rightbar_reducer(state = defaultState, action) {
  switch (action.type) {
    case act.SET_LINKS:
      return {
        ...state,
        links: action.payload,
      };
    case act.ADD_LINK:
      links = [...state.links.filter((l) => l.name !== action.payload.name)];
      links.unshift(action.payload);
      return {
        ...state,
        links,
        is_open: true,
      };
    case "ADD_SESSION":
      sessions = [...state.sessions.filter((s) => s.id !== action.payload.id)];
      sessions.unshift(cloneDeep(action.payload));
      return {
        ...state,
        sessions,
        is_open: true,
      };
    case "ADD_BLOCK":
      blocks = [...state.blocks.filter((b) => b.id !== action.payload.id)];
      blocks.unshift(cloneDeep(action.payload));
      return {
        ...state,
        blocks,
        is_open: true,
      };
    case "REMOVE_RIGHTBAR_ITEM":
      if (action.payload.type === "session") {
        sessions = [...state.sessions];
        sessions = sessions.filter((s) => s.id !== action.payload.id);
        return {
          ...state,
          sessions,
        };
      } else if (action.payload.type === "block") {
        blocks = [...state.blocks];
        blocks = blocks.filter((b) => b.id !== action.payload.id);
        return {
          ...state,
          blocks,
        };
      } else if (action.payload.type === "link") {
        links = [...state.links];
        links = links.filter((l) => l.name !== action.payload.id);
        return {
          ...state,
          links,
        };
      }
    case "SET_RIGHTBAR_OPEN":
      return {
        ...state,
        is_open: action.payload,
      };
    case "SET_TAG_SEARCH_RESULTS":
      return {
        ...state,
        tag_search_results: action.payload,
      };
    case "SET_TAB_SHOWING":
      return {
        ...state,
        tab_showing: action.payload,
      };
    case "SET_TAGGING_PROGRAM_OR_SESSION":
      return {
        ...state,
        tagging_type: action.payload,
      };
    default:
      return state;
  }
}
